import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from '@hydra/common/components';

export const FilePreview = ({ file }) => {
  const uri = file && file.uri;
  return uri
    ? <a href={uri} target='_blank' rel='noreferrer'><Translate content='pdf_editor_option_view_file' /></a>
    : <Translate content='pdf_editor_option_default_content_empty_text' />;
};

FilePreview.propTypes = {
  uri: PropTypes.string
};

export default React.memo(FilePreview);
